import Page from '../../classes/Page'
import Hero from '../../modules/Hero'
import { app } from '../../utils/store'
import each from 'lodash/each'

export default class TaxonomyRoom extends Page{
    constructor(){
        super({
            id : 'taxonomy_room',
            element: '[data-app-page]',
            elements: { 
                hero : document.querySelectorAll('[data-carousel="hero"]'),
                btn_kind : document.querySelectorAll('.kind .btn-kind'),
            }
        })
    }

    create() {
        super.create()
        if (this.elements.hero) {
            this.createHero();
        }
        if (this.elements.btn_kind){
            this.changeImage();
        }
    }

    createHero() {
        each(this.elements.hero, (entry) => { return new Hero({ element: entry }) })

    }

    changeImage = () => {
        const image_bg = this.element.querySelector('.image-bg');
        each(this.elements.btn_kind, (btn) => {
            btn.onmouseover = (event) => {
                let data_image_bg = event.target.getAttribute('data-image-bg');

                if (data_image_bg != image_bg.getAttribute('src')) {
                    image_bg.style.setProperty('opacity', '0');
                    setTimeout(() => {
                        image_bg.setAttribute('src', data_image_bg);
                        image_bg.style.setProperty('opacity', '1');
                    }, 200);
                }
            };
        })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}